import {
  delete_user_file,
  load_user_file_list,
  upload_user_file,
} from "../../actions/user_content";
import DocumentList from "../DocumentList";

const ProfileDocumentList = ({ profileId }) => {
  const documentListConfig = {
    loadFunction: load_user_file_list,
    uploadFunction: upload_user_file,
    deleteFunction: delete_user_file,
  };
  return (
    <DocumentList
      personId={profileId}
      documentListConfig={documentListConfig}
    />
  );
};

export default ProfileDocumentList;
